import {ChangeDetectorRef, Component} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {EbsComponentService} from "../../services/ebsComponentService";
import {EbsWebService} from "../../services/ebsWebService";
import {ImageViewerController} from "ionic-img-viewer";


@Component({
  selector: 'custom-body',
  templateUrl: 'custom-body.html',
  inputs: ['bodyData']
})
export class CustomBodyPage  {

  bodyData: any;
  _ebsComponentService:EbsComponentService;


  constructor(public navCtrl: NavController, public navParams: NavParams,private cdRef:ChangeDetectorRef, public  _ebsWebService: EbsWebService) {
    this._ebsComponentService = new EbsComponentService(_ebsWebService);

  }

  ionViewDidLoad() {
    this.cdRef.detectChanges();
  }


  openPage(item) {
    if (typeof item.Action != "undefined" && item.Action != "" && item.Action != null) {
      let navParams = {};
      if (item.ViewTypeAction=="Signature") {
        navParams = {
          signatureElement: item
        };
      } else {
        navParams = {
          title: item.ActionCaption,
          actionURL: item.Action,
          postParams: item.PostParameters
        };
      }
      this._ebsComponentService.navigationController(item,navParams,this.navCtrl);
    } else {
      return;
    }
  }



}



// WEBPACK FOOTER //
// ./src/components/custom-body/custom-body.ts